import * as React from 'react';
import { StarryUIIcon } from '../components/StarryUIIcon';

export const ChevronRightThin = ({ color = 'currentColor', ...icon }: image.IStarryUIIcon) => (
    <StarryUIIcon {...icon}>
        <path
            fill={color}
            d="M15.0427605,11.9276343 L7.08239,3.96726376 L8.04965376,3 L16.9376586,11.8880048 L16.8980291,11.9276343 L16.9376586,11.9672638 L8.04965376,20.8552686 L7.08239,19.8880048 L15.0427605,11.9276343 Z"
        />
    </StarryUIIcon>
);
